// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__75led","container":"styles_container__WQO4Q","footer":"styles_footer__MqgM9"};